import dayjs from 'dayjs';

const getFormattedDate = (time) => {
	const start = new Date(time);
	const st = dayjs(start).locale('de').format('DD. MMMM YYYY');
	return st;
};

export default getFormattedDate;